import React from "react"
import ActionButton from "./actionbutton.component"
import { FormattedMessage } from "react-intl"

type Props = {
    onClickCallback: () => void
    disabled?: boolean
    className?: string
}
export const SaveButton = (props: Props) => {
    return (
        <span className={"pr-2 m-0"}>
            <ActionButton
                className={"btn btn-primary" + (props.className ?? "")}
                onClick={props.onClickCallback}
                disabled={props.disabled ?? false}
            >
                <FormattedMessage
                    id="common.button.save"
                    defaultMessage="Save"
                />
            </ActionButton>
        </span>
    )
}


// WEBPACK FOOTER //
// ./src/common/button/SaveButton.tsx